import Label from "Components/Common/components/Label";
import PDWTracker from "Components/GMS/Pdw/PDWTracker";
import React from "react";
import { Modal } from "react-bootstrap";

const LogsPDW = (props) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
      show={props.showLogs}
      onHide={props.modalLogsClose}
    >
      <Modal.Header closeButton>
        <div>
          <Label message={"PDW Logs"} fontSize={0.875} fontWeight="600" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="m-2">
            <div className="">
              <PDWTracker />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogsPDW;
